import styled from "styled-components";

const HighlightSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  box-sizing: border-box;
`;

const HighlightSectionContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: ${({ maxWidth }) => maxWidth || "1400px"};
  box-sizing: border-box;

  padding: 96px 112px;
  gap: 52px;

  @media (max-width: 1400px) {
    padding: 80px 96px;
    gap: 48px;
  }

  @media (max-width: 1280px) {
    padding: 64px 80px;
    gap: 40px;
  }

  @media (max-width: 1024px) {
    padding: 48px 32px;
    gap: 32px;
  }

  @media (max-width: 768px) {
    padding: 32px 24px;
    gap: 24px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    // align-items: center;
  }

  @media (max-width: 480px) {
    padding: 24px ${({ mobileXPadding }) => mobileXPadding || "16px"};
    gap: 24px;
  }
`;

const HighlightImg = styled.img`
  position: absolute;
  z-index: 0;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;

  opacity: ${(props) => props.opacity || 0.5};
  -webkit-mask-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 200%
  );
  mask-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 200%
  );
`;

const HighlightItem = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.gap || "8px"};
  max-width: ${(props) => props.maxWidth || "240px"};
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: ${(props) => props.maxWidth || "180px"};
    justify-content: flex-start;
  }

  svg {
    path, rect, circle, polygon {
      stroke: ${props => props.stroke === 'none' ? 'none' : '#797979'};
      ${props => props.fill ? `fill: #797979;` : ''}
      transition: all 0.3s ease;
    }
  }

  &:hover {
    svg {
      path, rect, circle, polygon {
        stroke: ${props => props.stroke === 'none' ? 'none' : '#FF4F00'};
        ${props => props.fill ? `fill: #FF4F00;` : ''}
      }
    }
  }

  @media (max-width: 1400px) {
    svg {
      width: 120px;
      height: 120px;
    }
  }

  @media (max-width: 1400px) {
    svg {
      width: 96px;
      height: 96px;
    }
  }
`;

const HighlightIcon = styled.img`
  flex-shrink: 0;
  width: ${(props) => props.width || "40px"};
  height: ${(props) => props.height || "40px"};
  ${(props) => props.scale && `transform: scale(${props.scale});`}
  object-fit: cover;
`;

export {
  HighlightSection,
  HighlightSectionContent,
  HighlightImg,
  HighlightItem,
  HighlightIcon,
};
